import { render } from "./TypesIndexView.vue?vue&type=template&id=061d683a"
import script from "./TypesIndexView.vue?vue&type=script&lang=js"
export * from "./TypesIndexView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__